export const initialState = {
  notifications: [],
};